import { connect } from 'react-redux'
import { addTranslations, setFetchTranslateSuccess } from '../../redux/actions'
import { Main } from './app/components/main-view'

/**
 * Called by Redux after any state changes and used to forward the needed state fragments in the Redux store to the
 * required properties of the appropriate React component.
 *
 * @param {Object} state - the state from the Redux store
 * @return {Object} an object, whose keys are a subset of the required property names of the React component to be
 *                  connected to and the values are a selected sub-state from the Redux store
 */
// eslint-disable-next-line react-redux/mapStateToProps-no-store
function mapStateToProps(state) {
    const { translations } = state.translations || ''
    const { fetchTranslateSuccess } = state.fetchTranslateSuccess || ''
    return { fetchTranslateSuccess, translations }
}

/**
 * Called by Redux after any state changes and used to forward the needed Redux action functions to the required
 * properties of the appropriate React component.
 *
 * @param {function} dispatch - the Redux action dispatch function
 * @return {Object} an object, whose keys are a subset of the required property names of the React component to be
 *                  connected to and the values are Redux action functions.
 */
function mapDispatchToProps(dispatch) {
    return {
        addTranslations: translations => dispatch(addTranslations(translations)),
        setFetchTranslateSuccess: success => dispatch(setFetchTranslateSuccess(success))
    }
}

// The module main view as a wrapped component connected to a Redux store
// (the actual store is provided via a Provider element in the application).
// const View = connect(mapStateToProps, mapDispatchToProps)(MainWithRouter)

const MainView = connect(mapStateToProps, mapDispatchToProps)(Main)

// Defines an object that can be merged with the reducers of other modules
// and then passed to the combineReducers method of Redux.
// Important: This object must contain the reducers for *this* module only.
// Important: The key is the sub-state name for this module. Note that the sub-state name may be used
// by other modules as well. Do *not* rename the key w/o checking the index.js of all other modules.
// const reducers = {
//     me: handleMe
// }

// Export the Modux module API of expected properties
export {
    //  reducers,
    MainView
}
